import './AddService.scss';

import * as formik from 'formik';
import * as yup from 'yup';

import { useEffect, useRef, useState } from 'react';

import AppButton from '../../../commons/buttons/AppButton';
import AppContainer from '../../../commons/containers/AppContainer';
import AppCurrencyInput from '../../../commons/inputs/AppCurrencyInput';
import AppInput from '../../../commons/inputs/AppInput';
import AppLinkButton from '../../../commons/buttons/AppLinkButton';
import Form from 'react-bootstrap/Form';
import noImg from '../../../assets/images/no-img.jpg';

function AddService({ nextStep, backStep, category, serviceToEdit }) {
  const [initialValues, setInitialValues] = useState({
    name: '',
    value: '',
    duration: '',
  });

  const [value, setValue] = useState(0);
  const [imgLogo, setImgLogo] = useState();
  const fileInputRef = useRef(null);

  const isEditing = serviceToEdit != null && Object.keys(serviceToEdit).length > 0;

  useEffect(() => {
    if (isEditing) {
      setInitialValues({
        name: serviceToEdit.name || '',
        duration: serviceToEdit.duration || '',
        value: serviceToEdit.value || '',
      });
      setValue(serviceToEdit.value || 0);
    } else {
      setInitialValues({ name: '', duration: '', value: '' });
      setValue(0);
      setImgLogo(undefined);
    }
  }, [serviceToEdit, isEditing]);

  const { Formik } = formik;

  const schema = yup.object().shape({
    name: yup
      .string()
      .required('Nome do serviço é obrigatório')
      .max(100, 'Nome deve ter no máximo 100 caracteres'),
    duration: yup
      .number()
      .typeError('Duração deve ser um número')
      .required('Duração do serviço é obrigatória')
      .min(1, 'Duração mínima é 1 minuto')
      .max(1440, 'Duração máxima é 1440 minutos (24h)'),
  });

  function createOrUpdate(values) {
    const data = {
      ...values,
      value: value || serviceToEdit?.value || 0,
      categoryId: category.value,
      img: imgLogo,
    };
    if (nextStep) {
      nextStep(data);
    }
  }

  function handleChangeImgLogo(e) {
    const file = e.target.files?.[0];
    if (file) setImgLogo(file);
  }

  const handleChangeValue = (event, newValue) => {
    event.preventDefault();
    setValue(newValue);
  };

  function convertePorExtenso(minutos) {
    const num = parseInt(minutos, 10);
    if (isNaN(num) || num < 0) return '';

    const horas = Math.floor(num / 60);
    const minutosRestantes = num % 60;

    let resultado = '';

    if (horas > 0) {
      resultado += horas === 1 ? '1 hora' : `${horas} horas`;
    }

    if (minutosRestantes > 0) {
      if (resultado) resultado += ' e ';
      resultado += minutosRestantes === 1 ? '1 minuto' : `${minutosRestantes} minutos`;
    }

    return resultado || '0 minutos';
  }

  const previewSrc = (imgLogo && URL.createObjectURL(imgLogo)) || serviceToEdit?.logo || noImg;

  return (
    <AppContainer>
      <div className="add-service">
        <div className="add-service__category-info">
          O serviço será criado para a categoria:{' '}
          <strong>{category?.label || 'Não selecionada'}</strong>
        </div>

        <Formik
          validationSchema={schema}
          onSubmit={createOrUpdate}
          enableReinitialize
          initialValues={initialValues}
        >
          {({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit} className="add-service__form">
              {/* Preview da imagem */}
              <div className="add-service__image">
                <img
                  src={previewSrc}
                  alt="Prévia da imagem do serviço"
                  className="add-service__image-preview"
                />
                <div className="add-service__image-actions">
                  <AppLinkButton
                    name={imgLogo ? 'Trocar imagem' : 'Adicionar imagem'}
                    onClick={() => fileInputRef.current?.click()}
                    size="md"
                    variantStyle="outline"
                  />
                  {imgLogo && (
                    <AppLinkButton
                      name="Remover"
                      onClick={() => {
                        setImgLogo(undefined);
                        if (fileInputRef.current) fileInputRef.current.value = '';
                      }}
                      size="md"
                      variantStyle="ghost"
                    />
                  )}
                </div>
              </div>

              <input
                id="file-upload-logo"
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleChangeImgLogo}
                style={{ display: 'none' }}
              />

              {/* Nome do serviço */}
              <AppInput
                isRequired
                errors={errors}
                touched={touched}
                name="name"
                onChange={handleChange}
                value={values.name}
                type="text"
                label="Nome do serviço"
                placeholder="Ex.: Corte feminino"
              />

              {/* Duração */}
              <AppInput
                isRequired
                errors={errors}
                touched={touched}
                name="duration"
                onChange={handleChange}
                value={values.duration}
                formText={convertePorExtenso(values.duration)}
                type="number"
                label="Duração (minutos)"
                placeholder="Ex.: 60"
              />

              {/* Valor */}
              <AppCurrencyInput
                errors={errors}
                touched={touched}
                name="value"
                onChange={handleChangeValue}
                value={values.value}
                label="Valor (a partir de)"
                placeholder="R$ 0,00"
              />

              {/* Ações */}
              <div className="add-service__actions">
                <AppButton width="100%" type="submit" name="Próximo" size="lg" />
                <AppLinkButton onClick={backStep} width="100%" name="Voltar" />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </AppContainer>
  );
}

export default AddService;